import { router } from "expo-router";
import React, { useState } from "react";
import {
  Image,
  Modal,
  Platform,
  Pressable,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { useDispatch, useSelector } from "react-redux";
import FooterComponent from "../component/footer";
import { logout } from "../redux/actions/authactions";
import { useLanguage } from "./LanguageProvider";

export default function ProfileCard() {
  const profile =
    useSelector((state: any) => state?.auth?.profile?.user?.[0]) || null;
  const [modalVisible, setModalVisible] = useState(false);
  const [modalSuccessVisible, setModalSuccessVisible] = useState(false);
  const [modalFailedVisible, setModalFailedVisible] = useState(false);
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const handlelogout = async () => {
    const res = await dispatch(logout() as any);

    if (res.success === true) {
      // 💡 2. เคลียร์ความจำบราวเซอร์ให้สะอาดหมดจด เมื่อ Logout สำเร็จ
      if (Platform.OS === "web") {
        localStorage.removeItem("empcode");
        localStorage.removeItem("sessionExpiry");
      }

      setModalSuccessVisible(true);
    } else {
      setModalFailedVisible(true);
      console.log("Logout Failed:", res.message);
    }
  };

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[80%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center pt-2">
            <Image
              source={{
                uri: `https://emp-image.veninecopper.com/${profile?.EmpCode}.png`,
              }}
              className="w-36 h-36 rounded-full border-2 border-[#F17736]"
              resizeMode="contain"
            />
          </View>

          <View className="w-full items-center justify-center pt-5 pb-3">
            <Text className="text-2xl font-kanit py-1">
              {profile?.FullNameEng ? profile?.FullNameEng : t("no_data")}
            </Text>
            <Text className="text-lg text-gray-500 font-kanit">
              ({profile?.FullName ? profile?.FullName : t("no_data")})
            </Text>
          </View>

          <View className="w-full flex-1 justify-start mt-0">
            <View className="w-full flex-wrap flex-row justify-between">
              {/* คอลัมน์ซ้าย */}
              <View className="w-[48%]">
                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("employee_code")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.EmpCode ? profile?.EmpCode : t("no_data")}
                    </Text>
                  </View>
                </View>

                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("position")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.PositionNameEng
                        ? profile?.PositionNameEng
                        : t("no_data")}
                    </Text>
                  </View>
                </View>

                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("department")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.ParentOrgUnitNameEng
                        ? profile?.ParentOrgUnitNameEng
                        : t("no_data")}
                    </Text>
                  </View>
                </View>

                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("email")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.PersonnelEmail
                        ? profile?.PersonnelEmail
                        : t("no_data")}
                    </Text>
                  </View>
                </View>
              </View>

              {/* คอลัมน์ขวา */}
              <View className="w-[48%]">
                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("nickname")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.NickNameEng ? profile?.NickNameEng : t("no_data")}
                    </Text>
                  </View>
                </View>

                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("section")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.OrgUnitNameEng
                        ? profile?.OrgUnitNameEng
                        : t("no_data")}
                    </Text>
                  </View>
                </View>

                <View className="w-full items-start justify-start py-2">
                  <Text className="text-lg text-gray-500 font-kanit py-1">
                    {t("type")}
                  </Text>
                  <View className="w-full flex-row items-center justify-between py-3 rounded-md bg-gray-100 px-4">
                    <Text className="text-xl font-kanit">
                      {profile?.EmpType
                        ? profile?.EmpType
                        : t("no_data")}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>

          {/* ปุ่ม LOGOUT */}
          <View className="w-full items-center justify-center py-2 border-t pt-5 border-gray-300">
            <TouchableOpacity
              className="w-full bg-[#F17736] py-3 rounded-xl items-center shadow-sm"
              onPress={() => setModalVisible(true)}
            >
              <Text className="text-white text-lg font-kanit">
                {t("logout")}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#F17736" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("logout")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("confirmLogout")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Cancel Button */}
              <Pressable
                className="flex-1 bg-gray-300 py-2 rounded-lg mx-1"
                onPress={() => setModalVisible(false)}
              >
                <Text className="text-center text-gray-700 font-kanit">
                  {t("cancel")}
                </Text>
              </Pressable>

              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalVisible(false);
                  handlelogout();
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalSuccessVisible}
        onRequestClose={() => setModalSuccessVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="check-circle" size={28} color="#58d68d" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("success")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("logoutSuccess")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalSuccessVisible(false);
                  router.replace("/"); // 💡 3. เปลี่ยนจาก push เป็น replace กลับไปหน้าแรก
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>

      <Modal
        animationType="fade"
        transparent={true}
        visible={modalFailedVisible}
        onRequestClose={() => setModalFailedVisible(false)}
      >
        <View className="flex-1 justify-center items-center bg-black/50 px-4">
          <View className="bg-white rounded-lg p-6 w-full max-w-sm shadow-2xl">
            {/* Header */}
            <View className="flex-row items-center justify-center pb-3">
              <Icon name="exclamation-circle" size={28} color="#F17736" />
              <Text className="text-center text-xl font-kanit text-gray-800 pl-2">
                {t("error")}
              </Text>
            </View>

            {/* Message */}
            <Text className="text-center text-gray-600 font-kanit mb-6">
              {t("logoutFailed")}
            </Text>

            {/* Buttons */}
            <View className="flex-row justify-around">
              {/* Confirm Button */}
              <Pressable
                className="flex-1 bg-[#58d68d] py-2 rounded-lg mx-1"
                onPress={() => {
                  setModalFailedVisible(false);
                }}
              >
                <Text className="text-center text-white font-kanit">
                  {t("confirm")}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
}